<template>
  <div class="index container">
    <transition name="fade">
      <router-view @showParent="showParent"> </router-view>
    </transition>

    <div v-if="showParentPage">
      <v-breadcrumbs>
        <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
          >Home</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :exact="true"
          :to="{ name: 'staffRequirementSubmission', params: {} }"
          active
        >
          Staff Requirement Submissions
        </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="d-flex flex-column flex-sm-row mb-4">
        <date-picker
            label="Start Date"
            :show-icon="false"
            v-model="startDate"
            outlined
            dense
            hide-details
            class="mr-sm-2 flex-grow-1"
            clearable
          />

          <date-picker
            label="End Date"
            :show-icon="false"
            v-model="endDate"
            outlined
            dense
            hide-details
            class="ml-sm-2 my-2 my-sm-0 flex-grow-1"
            clearable
          />
          <v-btn @click="search" color="primary" class="mx-4">Filter</v-btn>
      </div>

      <div class="table-container">
        <v-data-table
          :headers="headers"
          :items="staffRequirementSubmissionList"
          :items-per-page="pagination.pageSize"
          :loading="!staffRequirementSubmissionProcessed"
          :server-items-length="pagination.totalSize"
          :page="pagination.current"
          :disable-pagination="
            !staffRequirementSubmissionList ||
              staffRequirementSubmissionList.length < 1
          "
          :hide-default-header="
            !staffRequirementSubmissionList ||
              staffRequirementSubmissionList.length < 1
          "
          :hide-default-footer="
            !staffRequirementSubmissionList ||
              staffRequirementSubmissionList.length < 1
          "
          :options.sync="options"
          item-key="id"
          class="elevation-1"
          @update:options="pageChanged"
        >
          <template v-slot:item.staffName="{ item }">
            <router-link :to="{name: 'staffView', params: {id: item.staffId}}">{{item.staffName ? item.staffName:'n/a'}}</router-link>
          </template>
          <template v-slot:item.requirements="{ item }">
            <v-menu
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >
                  {{item.requirements ? item.requirements.length : 0}} Requirements
                </span>
              </template>

              <v-list rounded>
                <v-list-item
                  v-for="r in item.requirements" 
                  :key="`${r.requirementId}-${r.forDoseNumber}`"
                >
                  <v-list-item-title>
                    {{r.requirementName}} 
                    <span class="ml-4 text-caption font-weight-light" v-if="r.cerfIssueDate && r.cerfExpireDate">
                      {{ r.cerfIssueDate | formatDateYear }} - {{ r.cerfExpireDate | formatDateYear }}
                    </span>
                    <span class="ml-4 text-caption font-weight-light" v-if="r.type == 'Vaccination' && r.forDoseNumber">
                      Dose {{ r.forDoseNumber }}
                    </span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn :to="{name: 'staffRequirementSubmissionView', params: {id: item.id }}" icon>
              <v-icon small>mdi-open-in-new</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.createdAt="{ item }">
            <span v-if="item.createdByName">By {{item.createdByName }} on</span> {{item.createdAt | formatDateYear}} <span v-if="item.submissionMethod">via {{item.submissionMethod}}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="edit(item)">
              mdi-pencil
            </v-icon>
            <!-- <v-icon small class="mr-2" @click="remove(item)">
              mdi-delete
            </v-icon> -->
          </template>
        </v-data-table>
      </div>
    </div>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
import moment from 'moment';

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100
      },
      options: {
        //define default sorting option here.
        sortBy: [],
        sortDesc: []
      },
      staffRequirementSubmissionList: [],
      showParentPage: true,
      startDate: moment().subtract(7, 'days').format('yyyy-MM-DD'),
      endDate: moment().format('yyyy-MM-DD'),
      headers: [
        {
          text: "staff",
          value: "staffName",
          align: "start",
          sortable: false
        },
        {
          text: "Requirements",
          value: "requirements",
          align: "start",
          sortable: false
        },
        {
          text: "Submitted By",
          value: "createdAt",
          align: "start",
          sortable: true
        },
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
      sort: {
        key: null
      },
      searchTerms: ""
    };
  },
  components: {
    ConfirmationDialog,
  },
  computed: {
    ...mapGetters("staffRequirementSubmission", [
      "staffRequirementSubmissionProcessed",
      "getstaffRequirementSubmissions"
    ])
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage"
    ]),
    ...mapActions("staffRequirementSubmission", [
      "deleteStaffRequirementSubmission",
      "fetchStaffRequirementSubmissions"
    ]),
    view(item) {
      this.$router.push({
        name: "staffRequirementSubmissionView",
        params: { id: item.id }
      });
    },
    edit(item) {
      this.$router.push({
        name: "staffRequirementSubmissionEdit",
        params: { id: item.id }
      });
    },
    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this submission?"
      );
      if (confirm) {
        this.deleteStaffRequirementSubmission(item.id)
          .then(() => {
            this.addSuccessMessage(
              "submission was deleted with successfully"
            );
            this.getResources();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
    getResources() {
      //skip if parent page is not showing...
      if(!this.showParentPage){
        return;
      }

      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;
      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        startDate: this.startDate,
        endDate: this.endDate
      };
      this.fetchStaffRequirementSubmissions(params)
        .then(response => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.staffRequirementSubmissionList = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    },
    search() {
      this.getResources();
    },
    clearSearch() {
      this.searchTerms = null;
      this.getResources();
    }
  },
  watch: {
    "pagination.numberRegisterForPage": function() {
      this.pagination.current = -1;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  }
};
</script>
